/**
 * Pylon 2 left leg — display names for monitor charts.
 */
import { buildDefaultStrainLabels } from '../../utils/sensorDisplayName';

export const SENSOR_LABELS = {
  ...buildDefaultStrainLabels(17),
};
